export default __webpack_public_path__ + "static/media/placing.a3439085.svg";